let audioCtx = null
let ultimoToqueEm = 0

function contextoAudio() {
  if (typeof window === 'undefined') return null
  const Ctx = window.AudioContext || window.webkitAudioContext
  if (!Ctx) return null
  if (!audioCtx) audioCtx = new Ctx()
  return audioCtx
}

/** Navegadores só liberam som depois de um clique/tecla. */
export function desbloquearAvisoWhatsApp() {
  const ctx = contextoAudio()
  if (!ctx) return
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {})
  }
}

function tom(ctx, inicio, frequencia, duracao, ganho) {
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()
  osc.type = 'sine'
  osc.frequency.setValueAtTime(frequencia, inicio)
  gain.gain.setValueAtTime(0.0001, inicio)
  gain.gain.exponentialRampToValueAtTime(ganho, inicio + 0.02)
  gain.gain.exponentialRampToValueAtTime(0.0001, inicio + duracao)
  osc.connect(gain)
  gain.connect(ctx.destination)
  osc.start(inicio)
  osc.stop(inicio + duracao + 0.02)
}

/** Dois toques curtos, no estilo notificação de chat. */
export function tocarAvisoWhatsApp() {
  const agora = Date.now()
  if (agora - ultimoToqueEm < 700) return
  ultimoToqueEm = agora

  try {
    const ctx = contextoAudio()
    if (!ctx) return
    const tocar = () => {
      const t = ctx.currentTime
      tom(ctx, t, 880, 0.11, 0.12)
      tom(ctx, t + 0.13, 1318, 0.16, 0.14)
    }
    if (ctx.state === 'suspended') {
      ctx.resume().then(tocar).catch(() => {})
      return
    }
    tocar()
  } catch {
    // Sem áudio disponível no dispositivo
  }
}
